import React from "react";
import styles from "./WorkHero.module.css";

import hero from "../../../../assets/Images/TsundokuAdminStudio/Demo.webp";

const WorkHero = () => {
  return (
    <>
      <div className={styles.entireHero}>
        <div className={styles.heroContainer}>
          <div className={styles.heroImageContainer}>
            <img
              src={hero}
              alt="Hero for the Tsundoku Admin Studio project"
              className={styles.heroImage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkHero;
